const modalEditPhotoFormEquip = {
  title: 'Editar foto do Equipamento'
};

export default modalEditPhotoFormEquip;
